import type { SxProps, Theme } from "@mui/material";
import type { OpsTatStatus } from "../../../../../../models/Dashboard/OpsTat/OpsTatFilters";

export type DailyTasksChipTone = "ok" | "warn" | "bad" | "info" | "neutral";

export const getDailyTasksChipColors = (
  theme: Theme,
  tone: DailyTasksChipTone,
): { bg: string; fg: string } => {
  try {
    const colors = theme.palette.customColors;
    if (tone === "bad") {
      return { bg: `${colors.errorRed}1A`, fg: colors.errorRed };
    }
    if (tone === "warn") {
      return { bg: colors.lightOrange, fg: theme.palette.orange.dark };
    }
    if (tone === "ok") {
      return {
        bg: colors.successGreenLightBackground,
        fg: colors.successGreen,
      };
    }
    if (tone === "info") {
      return { bg: colors.lightBlue, fg: colors.darkBlue };
    }
    return { bg: colors.veryLightGray, fg: colors.navyText };
  } catch (error) {
    console.error("Failed to resolve daily tasks chip colors:", error);
    return { bg: "#F3F4F6", fg: "#1F2A44" };
  }
};

export const dailyTasksStatusTone = (
  status: OpsTatStatus | undefined,
): DailyTasksChipTone => {
  if (status === "ok") return "ok";
  if (status === "warn") return "warn";
  if (status === "bad") return "bad";
  return "neutral";
};

export const dailyTasksStatusPillSx = (
  theme: Theme,
  status: OpsTatStatus | undefined,
): SxProps<Theme> => {
  const { bg, fg } = getDailyTasksChipColors(
    theme,
    dailyTasksStatusTone(status),
  );
  return {
    display: "inline-flex",
    alignItems: "center",
    px: 1,
    py: 0.25,
    borderRadius: 1,
    bgcolor: bg,
    color: fg,
    border: `1px solid ${fg}33`,
  };
};

export const dailyTasksChipSx = (
  theme: Theme,
  tone: DailyTasksChipTone,
): SxProps<Theme> => {
  const { bg, fg } = getDailyTasksChipColors(theme, tone);
  return {
    height: 22,
    fontSize: "0.7rem",
    fontWeight: 600,
    bgcolor: bg,
    color: fg,
    border: `1px solid ${fg}33`,
    "& .MuiChip-label": {
      color: fg,
      fontWeight: 600,
    },
  };
};
